//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isEternal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      desktopSubHeading: '',
      desktopHeadingPrefix: '',
      desktopHeading: '',
      desktopHeadingPostfix: '',
    };
  },
  created() {
    if (this.isEternal) {
      this.desktopSubHeading =
        this.$te('saleBlock.eternal.desktopSubHeading') &&
        this.$t('saleBlock.eternal.desktopSubHeading');
      this.desktopHeadingPrefix =
        this.$te('saleBlock.eternal.desktopHeadingPrefix') &&
        this.$t('saleBlock.eternal.desktopHeadingPrefix');
      this.desktopHeading = this.$t('saleBlock.eternal.desktopHeading');
      this.desktopHeadingPostfix =
        this.$te('saleBlock.eternal.desktopHeadingPostfix') &&
        this.$t('saleBlock.eternal.desktopHeadingPostfix');
    } else {
      this.desktopSubHeading =
        this.$te('saleBlock.desktopSubHeading') &&
        this.$t('saleBlock.desktopSubHeading');
      this.desktopHeadingPrefix =
        this.$te('saleBlock.desktopHeadingPrefix') &&
        this.$t('saleBlock.desktopHeadingPrefix');
      this.desktopHeading = this.$t('saleBlock.desktopHeading');
      this.desktopHeadingPostfix =
        this.$te('saleBlock.desktopHeadingPostfix') &&
        this.$t('saleBlock.desktopHeadingPostfix');
    }
  },
};
